module.exports = __webpack_public_path__ + "img/service_wechat_2.f2b513c7.jpg";